import * as React from "react"
import { LogoSkeleton, LogoProps } from "./skeleton"

export function ContentstackLogo(props: LogoProps) {
  return (
    <LogoSkeleton {...props} logoName="ContentstackLogo">
      <path
        d="M15.3851 8.31371C15.3851 8.51206 15.264 8.64429 15.0823 8.64429H9.328C9.14629 8.64429 9.02515 8.51206 9.02515 8.31371V7.58644C9.02515 7.38809 9.14629 7.25586 9.328 7.25586H15.0823C15.264 7.25586 15.3851 7.38809 15.3851 7.58644V8.31371Z"
        fill="#EE5644"
      />
      <path
        d="M17.9289 10.3635C17.9289 10.5619 17.8078 10.6941 17.626 10.6941H10.5392C10.3575 10.6941 10.2363 10.5619 10.2363 10.3635V9.63624C10.2363 9.4379 10.3575 9.30566 10.5392 9.30566H17.5655C17.7472 9.30566 17.8683 9.4379 17.8683 9.63624L17.9289 10.3635Z"
        fill="#EE5644"
      />
      <path
        d="M19.8671 12.4788C19.8671 12.6771 19.746 12.8093 19.5643 12.8093H11.8717C11.69 12.8093 11.5688 12.6771 11.5688 12.4788V11.7515C11.5688 11.5531 11.69 11.4209 11.8717 11.4209H19.5643C19.746 11.4209 19.8671 11.5531 19.8671 11.7515V12.4788Z"
        fill="#EE5644"
      />
      <path
        d="M19.8671 14.595C19.8671 14.7933 19.746 14.9255 19.5643 14.9255H11.8717C11.69 14.9255 11.5688 14.7933 11.5688 14.595V13.8677C11.5688 13.6693 11.69 13.5371 11.8717 13.5371H19.5643C19.746 13.5371 19.8671 13.6693 19.8671 13.8677V14.595Z"
        fill="#EE5644"
      />
      <path
        d="M17.9289 16.6448C17.9289 16.8431 17.8078 16.9753 17.626 16.9753H10.5392C10.3575 16.9753 10.2363 16.8431 10.2363 16.6448V15.9175C10.2363 15.7191 10.3575 15.5869 10.5392 15.5869H17.5655C17.7472 15.5869 17.8683 15.7191 17.8683 15.9175L17.9289 16.6448Z"
        fill="#EE5644"
      />
      <path
        d="M15.3851 18.76C15.3851 18.9584 15.264 19.0906 15.0823 19.0906H9.328C9.14629 19.0906 9.02515 18.9584 9.02515 18.76V18.0327C9.02515 17.8344 9.14629 17.7021 9.328 17.7021H15.0823C15.264 17.7021 15.3851 17.8344 15.3851 18.0327V18.76Z"
        fill="#EE5644"
      />
      <path
        d="M4.48242 1.96703C4.48242 2.16538 4.60356 2.29761 4.78528 2.29761H10.5396C10.7213 2.29761 10.8424 2.16538 10.8424 1.96703V1.23976C10.8424 1.04141 10.7213 0.90918 10.5396 0.90918H4.78528C4.60356 0.90918 4.48242 1.04141 4.48242 1.23976V1.96703Z"
        fill="#EE5644"
      />
      <path
        d="M1.93872 4.08227C1.93872 4.28062 2.05986 4.41285 2.24158 4.41285H9.26784C9.44956 4.41285 9.5707 4.28062 9.5707 4.08227V3.35499C9.5707 3.15665 9.44956 3.02441 9.26784 3.02441H2.24158C2.05986 3.02441 1.93872 3.15665 1.93872 3.35499V4.08227Z"
        fill="#EE5644"
      />
      <path
        d="M0 6.19848C0 6.39683 0.121143 6.52906 0.302857 6.52906H7.99543C8.17714 6.52906 8.29828 6.39683 8.29828 6.19848V5.4712C8.29828 5.27286 8.17714 5.14062 7.99543 5.14062H0.302857C0.121143 5.14062 0 5.27286 0 5.4712V6.19848Z"
        fill="#EE5644"
      />
      <path
        d="M0 8.31371C0 8.51206 0.121143 8.64429 0.302857 8.64429H7.99543C8.17714 8.64429 8.29828 8.51206 8.29828 8.31371V7.58644C8.29828 7.38809 8.17714 7.25586 7.99543 7.25586H0.302857C0.121143 7.25586 0 7.38809 0 7.58644V8.31371Z"
        fill="#EE5644"
      />
      <path
        d="M1.93872 10.3635C1.93872 10.5619 2.05986 10.6941 2.24158 10.6941H9.26784C9.44956 10.6941 9.5707 10.5619 9.5707 10.3635V9.63624C9.5707 9.43789 9.44956 9.30566 9.26784 9.30566H2.24158C2.05986 9.30566 1.93872 9.43789 1.93872 9.63624V10.3635Z"
        fill="#EE5644"
      />
      <path
        d="M4.48242 12.4788C4.48242 12.6771 4.60356 12.8093 4.78528 12.8093H10.5396C10.7213 12.8093 10.8424 12.6771 10.8424 12.4788V11.7515C10.8424 11.5531 10.7213 11.4209 10.5396 11.4209H4.78528C4.60356 11.4209 4.48242 11.5531 4.48242 11.7515V12.4788Z"
        fill="#EE5644"
      />
    </LogoSkeleton>
  )
}
